import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export enum CreditReviewBuyerRequestType {
    IdentityVerification = 'identity-verification',
    BusinessVerification = 'business-verification',
    PersonalGuarantee = 'personal-guarantee',
    BankAccountActivity = 'bank-account-activity',
    FinancialDocument = 'financial-document',
    CreditReferences = 'credit-references',
    CreditLine = 'credit-line',
}

export const CreditReviewBuyerRequestSchema = z.object({
    email: z.string().email(),
    link: z.string(),
    buyer: z.string(),
    type: EnumSchema(CreditReviewBuyerRequestType),
});

export class CreditReviewBuyerRequest extends FromSchema(CreditReviewBuyerRequestSchema) {
    email: string;
    link: string;
    buyer: string;
    type: CreditReviewBuyerRequestType;
}
